import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'UIStoryStatus',
    props: {
        status: { default: "locked" }
    },
    setup(__props) {
        const props = __props;
        const icon = computed(() => (({
            "locked": "",
            "unlocked": "",
            "active": "selector",
            "completed": "check"
        })[props.status]));
        return (_ctx, _cache) => {
            const _component_UIIcon = _resolveComponent("UIIcon");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["UIStoryStatus size-24 inline-grid place-items-center rounded-full", [`UIStoryStatus--${_ctx.status}`, _ctx.status === 'active' ? 'text-accent' : 'text-white']])
            }, [
                (icon.value)
                    ? (_openBlock(), _createBlock(_component_UIIcon, {
                        key: 0,
                        name: icon.value,
                        class: "row-start-1 col-start-1 text-16"
                    }, null, 8, ["name"]))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
